// extracted by mini-css-extract-plugin
module.exports = {"matchScoreboard":"_4zX6N","banner":"FB_3R","sticky":"_1XVYo","stickyContent":"zFG9l"};